import { Quaternion, Vector3 } from 'three'
import type { RNGConfig } from '../../core/rng/RNGConfig.type'
import { next } from '../../core/rng/index'
import { TWO_PI } from '../../core/util/math/Math'

// Create a random quaternion rotation
export default function setRandomQuaternion(rng: RNGConfig, q: Quaternion): void {
  const axis = new Vector3(
    next(rng) * 2 - 1,
    next(rng) * 2 - 1,
    next(rng) * 2 - 1
  ).normalize()
  const angle = next(rng) * TWO_PI
  q.setFromAxisAngle(axis, angle)
}
